/**
 * 会议 AI 产出状态轮询的终止判据。
 *
 * 单独成一个纯函数而不是写在 hook 里：终止保证是这段逻辑的全部价值，必须能被直接
 * 验证。少了终止条件，一条卡在「生成中」的记录会让界面无限轮询下去。
 */

import type { MeetingAnalysisState } from "../types/meeting";

/** 轮询间隔。与语音转写状态轮询取同一节奏。 */
export const MEETING_AI_POLL_INTERVAL_MS = 3000;

/**
 * 连续处于「生成中」的时长上限。
 *
 * 服务端对一次产出的等待上限是 5 分钟，超出后状态读出来即为失败，因此正常路径下
 * 轮询由状态本身终止。这道时长闸只覆盖状态始终读不到终态的异常情形，使轮询在任何
 * 后端行为下都会停下来。
 */
export const MEETING_AI_POLL_MAX_MS = 8 * 60 * 1000;

/**
 * 下一次轮询要等多久；返回 false 表示停止轮询。
 *
 * @param state 最近一次读到的产出状态；未读到时传 undefined。
 * @param pollStartedAt 本轮「生成中」第一次被读到的时刻；尚未开始传 null。
 * @param now 当前时刻。
 */
export function meetingAiPollInterval(
  state: MeetingAnalysisState | undefined,
  pollStartedAt: number | null,
  now: number,
): number | false {
  // 「已就绪」「未完成」「未生成」都是终态，不再轮询。状态读不到时同样不轮询——
  // 没有依据说明有产出在途。
  if (state !== "pending") return false;
  if (pollStartedAt !== null && now - pollStartedAt > MEETING_AI_POLL_MAX_MS) {
    return false;
  }
  return MEETING_AI_POLL_INTERVAL_MS;
}
